var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var { isNil } = require('lodash');

var defaultMessages = require('../../i18n/messages/default');
var IntlProvider = ReactIntl.IntlProvider;
var Footer = require('../Footer/Footer');
var Header = require('../Header/Header');
var LoginActions = require('../../actions/LoginActions');
var LoginStore = require('../../stores/LoginStore');
var AppConstants = require('../../constants/AppConstants')
var UrlUtils = require('../../utils/urlUtils');
var createReactClass = require('create-react-class');
var PageCase = require('../PageCase/PageCase.js');
var LoginBoxWrapper = require('../LoginBoxWrapper/LoginBoxWrapper.js');
var { Input, Button } = require('metro-ui-components');
var LoginHiddenFields = require('../Login/LoginHiddenFields.js');
var PasswordField = require('../Password/PasswordField.js');
var LoginHelper = require('../../utils/loginHelper.js');
var LoginHandler = require('../Login/LoginHandler.js');
var TwoFactorAuthenticationRenderer = require('../TwoFactorAuthenticationRenderer/TwoFactorAuthenticationRenderer.js');
var AuthMethodsHandler = require('../Login/AuthMethodsHandler.js');
var ReCaptcha = require('../../utils/ReCaptcha');

var DeveloperLogin = createReactClass({
    displayName: 'DeveloperLogin',

    getInitialState() {
        return {
            localeId: this.props.localeId,
            userMFAMethods: []
        };
    },

    finalRedirectUri: '',

    componentDidMount: function () {
        LoginStore.addChangeListener(this._onFooterConfigChange);
        this.renderConfirmation(this.props.emailSentForgotPassword);
        ReCaptcha.attachRecaptchaScript(this.props.clientId, this.props.realmId);
    },
    
    _onFooterConfigChange: function () {
        let appState = LoginStore.getState();
        this.setState({ forgotPwdLinkUrl: appState.forgotPwdLinkUrl });
    },

    onLogin(evt) {
        const { loginId, password, localeId} = this.state;
        evt.preventDefault();
 
        if (!(loginId && password)) {
            return;
        }

        evt.preventDefault();
        if (UrlUtils.isSamlFlow()) {
            LoginActions.submitSamlLogin(loginId, password, this.props.userType, this.props.clientId, this.props.countryCode, localeId, this.props.realmId, this.props.traceId);
        } else {
            ReCaptcha.getRecaptchaToken((token) =>
                LoginActions.submitLogin(loginId, password, this.props.userType, this.props.clientId,
                    this.props.responseType, this.props.countryCode, localeId, this.props.realmId,
                    this.props.accountId, this.props.redirectUrl, this.props.state, this.props.prompt, this.props.nonce, this.props.scope,
                    this.props.traceId, this.props.codeChallenge, this.props.codeChallengeMethod, token)
            );
        }
    },

    onLoginIdChange(e, value) {
        this.setState({ loginId: value });
    },

    onPasswordChange(password) {
        this.setState({ password: password });
    },

    onLocalChange(localeId) {
        this.setState({ localeId: localeId });
    },

    renderTwoFactorAuthenticationComponent() {
        return (
            <TwoFactorAuthenticationRenderer
                {... this.props}
                phone={this.state.phone}
                emailId={this.state.emailId}
                login={this.state.loginId}
                idToken={this.state.idToken}
                userId={this.state.userId}
                credentialId={this.state.credentialId}
                authMethodDeviceName={this.state.authMethodDeviceName}
                directOtpRedirectUri={this.finalRedirectUri}
                twoFaAuthMethod={this.state.showTOTPControl}
                userMFAMethods={this.state.userMFAMethods}
                showTryOtherLink={this.state.userMFAMethods ? this.state.userMFAMethods.length > 1 : false}
            />
        );
    },

    setLoginState(value) {
        this.setState(value)
    },

    renderConfirmation(code) {

        if (code == AppConstants.EmailSentCode.FORGOTPASSWORD) {
          // 200 represents the forgot password mail is successfully sent 
          LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['emailSentForgotPasswordConfirmationMasg']), "success");
        } else if (code == AppConstants.EmailSentCode.RESETPASSWORD) {
          // 300 represents the reset password is successfully done
          LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['emailSentResetPasswordConfirmationMasg']), "success");
        } else if (code == AppConstants.EmailSentCode.RESETPASSWORDERROR) {
          // 400 represents the some problem is reset password flow
          LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['resetPasswordError']), "error");
        } else if (code == AppConstants.EmailSentCode.VALIDATETOTPERROR) {
          // 400 represents the some problem is reset password flow
          LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]]), "error");
        }
      },

    renderLogin() {
        const label = this.props.intl.formatMessage(defaultMessages['userName']);
        const loginButtonText = this.props.intl.formatMessage(defaultMessages['loginBtnTxt']);

        
        return (
            <LoginBoxWrapper>
                <div>
                    <form id="authForm" noValidate="novalidate" onSubmit={this.onLogin} autoComplete="off" >
                        <Input
                            id="user_id"
                            type="email"
                            key="user_id"
                            name="user_id"
                            autoComplete="off"
                            label={label}
                            required={true}
                            hasWarning={this.state.loginError ? true : false}
                            value={this.state.loginId}
                            onChange={this.onLoginIdChange.bind(this)}
                            onKeyUp={this.onLoginIdChange.bind(this)}
                            onKeyDown={this.onLoginIdChange.bind(this)}
                            autoFocus={true}
                        />
                        <PasswordField
                            {... this.props}
                            onPasswordChange={this.onPasswordChange} />
                        <LoginHiddenFields {... this.props} />
                        <Button
                            id="submit"
                            type="submit"
                            value="submit"
                            kind="primaryRaised"
                            size="large"
                            className="primary-button"
                            disabled={!(this.state.loginId && this.state.password)}>
                            {loginButtonText}
                        </Button>
                    </form>

                    {/* TODO: Needs to be added back one Forgot password functionality is required */}

                    <div className="row">
                        <div className="forgotPasswordLink">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div>
                                    {this.state.forgotPwdLinkUrl &&
                                        <a href={this.state.forgotPwdLinkUrl} className="blue-labels">
                                            {this.props.intl.formatMessage(defaultMessages['forgotPassword'])}
                                        </a>
                                    }
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            </div>
                        </div>
                    </div>
                </div>
            </LoginBoxWrapper>
        );
    },

    renderContent: function () {
        let props = this.props;
        let bodyHeader = LoginHelper.getwelcomeToMetroDigitalText(props);
        let headerMessage = LoginHelper.getloginHeader(props);
        let renderedComponent = this.state.showTOTPControl ? this.renderTwoFactorAuthenticationComponent() : this.renderLogin();

        return (
            <div className="portraitCenteredEmployee">
                <div className="welcomeTitle">
                    <span id="welcomeToMetroDigital">
                        {bodyHeader}
                    </span>
                </div>
                <div className="employeeBoxContainer container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                        <div className="row whiteContainer larger-device-width smaller-device">
                            <div className="col-xs-12 smaller-device-inside-wrap">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="form-group centreAligned loginHeader">
                                            <span>{headerMessage}</span>
                                        </ div>
                                    </div>
                                </div>
                                {renderedComponent}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
                <LoginHandler {...props} localeId={this.state.localeId} setState={this.setLoginState.bind(this)} />
                <AuthMethodsHandler {...props} setState={this.setLoginState.bind(this)} />
            </div>
        )
    },

    renderFooter: function () {
        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}>
                <div className='fixFooterBottom'>
                    <Footer {...this.props} locale={this.state.localeId} onLocalChange={this.onLocalChange} />
                </div>
            </IntlProvider>
        )
    },
    render: function () {
        return (
            <PageCase
                header={< Header countryCode={this.props.countryCode} />}
                content={this.renderContent()}
                footer={this.renderFooter()}></PageCase>
        );
    }
});

module.exports = injectIntl(DeveloperLogin);
